/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { isArray, isNil } from 'lodash';

const useHasPermission = () => {
    const userAllPermissionList: string = useSelector((state: any) => state.userData.PermissionList);
    const partnerSettings: Record<string, boolean> = useSelector((state: any) => state.partnerSettings);

    const isLoadingPartnerSettings = !('Id' in partnerSettings);

    const hasPermission = useCallback(
        (permissions: string | string[], isAllMandatory = false) => {
            if (!isNil(userAllPermissionList)) {
                if (isArray(permissions)) {
                    if (isAllMandatory) {
                        const existsPermissions: any[] = [];
                        permissions.forEach((permission) => {
                            userAllPermissionList.includes(permission) && existsPermissions.push(permission);
                        });
                        return existsPermissions.length === permissions.length;
                    } else {
                        return permissions.some((permission) => userAllPermissionList.includes(permission));
                    }
                } else {
                    return userAllPermissionList.includes(permissions);
                }
            }
        },
        [userAllPermissionList],
    );

    const hasPartnerSettings = useCallback(
        (settingsKey: string) => {
            return partnerSettings[settingsKey];
        },
        [partnerSettings],
    );

    return { hasPermission, hasPartnerSettings, isLoadingPartnerSettings };
};

export default useHasPermission;
